{
  "id": "league_3c60897b-25cf-4b37-9d1a-8554c1198f28",
  "name": "Gods of the Arena",
  "url": "https://softmax.com/watch?league=league_3c60897b-25cf-4b37-9d1a-8554c1198f28",
  "coworldName": "Gods of the Arena"
}
